"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));
var WindowTitle = exports.default = /*#__PURE__*/function () {
  function WindowTitle(state) {
    var _this = this;
    (0, _classCallCheck2.default)(this, WindowTitle);
    this.state = state;
    this.title = state.settings.windowTitle || '';
    this.alert = false;

    // Update the window title if we have one
    if (state.settings.windowTitle) {
      this.updateTitle();
    }
    state.$watch('settings.windowTitle', function (newVal) {
      _this.updateTitle(newVal);
    });
    state.$watch('ui.app_has_focus', function (newVal) {
      if (newVal && _this.alertTmr) {
        _this.stopAlert();
      }
    });
    state.$on('notification.title', function (enable) {
      if (enable) {
        _this.startAlert();
      } else {
        _this.stopAlert();
      }
    });
  }
  (0, _createClass2.default)(WindowTitle, [{
    key: "startAlert",
    value: function startAlert() {
      var _this2 = this;
      if (this.alertTmr) {
        return;
      }
      this.alertTmr = setInterval(function () {
        _this2.updateTitle();
      }, 1000);
    }
  }, {
    key: "stopAlert",
    value: function stopAlert() {
      if (this.alertTmr) {
        clearInterval(this.alertTmr);
        this.alertTmr = null;
      }
      this.updateTitle();
    }
  }, {
    key: "updateTitle",
    value: function updateTitle(newTitle) {
      if (typeof newTitle === 'string') {
        this.title = newTitle;
      }
      if (this.alertTmr && !this.alert) {
        window.document.title = '* ' + this.title;
        this.alert = true;
      } else {
        window.document.title = this.title;
        this.alert = false;
      }
    }
  }]);
  return WindowTitle;
}();